/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react/macro';

import { Page, PagePanel } from 'components/Page';
import { StylingContextState } from 'context/Styling';
import { PUBLIC_URL } from 'utils/consts';
import { useLocationState } from 'utils/router';
import { useStyles } from 'utils/useStyles';

import { MfaSetupWizard } from './MfaSetupWizard';
import {useMfaRedirect} from "../../hooks/useMfaRedirect";

const getStyles = ({ colors }: StylingContextState) => ({
  pageStyleOverride: css`
    #page-content {
      background-color: ${colors.white};
      box-shadow: 0px 32px 48px 0px rgba(0, 0, 0, 0.05) !important;
      width: 610px;

      @media (max-width: 768px) {
        margin: 24px;
        padding: 48px;
        width: 90%;
      }

      @media (max-width: 550px) {
        padding: 24px 0;
        max-width: 414px;
      }
    }
    #page-panels,
    #panel {
      width: 100%;

      @media (max-width: 768px) {
        padding: 0px;
        margin: 0px;
        width: 100%;
      }

      @media (max-width: 550px) {
        padding: 0 24px;
      }
    }
  `,
  logoContainer: css`
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;
  `,
  logo: css`
    height: 32px;
    width: auto;
  `,
});

export const MfaSetup = () => {
  const styles = useStyles(getStyles);
  const locationState = useLocationState<{ setupRequired?: boolean }>();
  const isRequired = locationState.setupRequired === true;
  const redirectAfterSuccess = useMfaRedirect();

  return (
    <Page
      title="MFA Setup"
      headingWidth="full"
      css={styles.pageStyleOverride}
    >
      <PagePanel id="panel" type="full">
        <div css={styles.logoContainer}>
          <img src={`${PUBLIC_URL}/img/grafana-cloud-logo-for-light-theme.svg`} alt="Grafana Cloud" css={styles.logo} />
        </div>
        <MfaSetupWizard onComplete={redirectAfterSuccess} onSkip={isRequired ? undefined : redirectAfterSuccess} />
      </PagePanel>
    </Page>
  );
};

